module.exports = __webpack_public_path__ + "img/cgal-06.29a53685.jpg";